/**
 * ScheduleStatus entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import dayjs from 'dayjs';

export const IDENTS = {
    SCHEDULED: 'scheduled',
    CANCELLED: 'cancelled',
    POSTPONED: 'postponed',
    RESCHEDULED: 'rescheduled',
};

export class ScheduleStatus extends BaseModel {
    defaults() {
        return {
            id: null,
            ident: null,
            value: null,
            creator_id: null,
            created: null,
            modifier_id: null,
            modified: null,
            creator: null,
            creator_firstname: null,
            creator_lastname: null,
            modifier: null,
            modifier_firstname: null,
            modifier_lastname: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            creator_id: Number,
            created: dayjs,
            modifier_id: Number,
            modified: dayjs,
        };
    }

    entityName() {
        return 'ScheduleStatus';
    }
}

export class ScheduleStatusCollection extends BaseCollection {
    options() {
        return {
            model: ScheduleStatus,
        };
    }

    entityName() {
        return 'ScheduleStatus';
    }
}
